import uuid from 'uuid';

var response = function (request, callback, data) {
	this.socket.removeAllListeners('response_'+request);
	var response = JSON.parse(data);
	if (response.error) {
		if (__DEVELOPMENT__) {
			console.log('API Error', response.error);
		}
		callback(response.error, null);
	}
	else {
		try {
			const json = JSON.parse(data);
			if (json) {
				if (__DEVELOPMENT__) {
					console.log('API Response', json);
				}
				callback(null, json.result);
			}
		} catch(e) {
			if (__DEVELOPMENT__) {
				console.log('API Error', data);
			}
			callback(data, null);
		}
	}
};


var WebsocketsRpc = function(socket) {
	this.socket = socket;
};

WebsocketsRpc.prototype.call = function(method, args, callback) {
	var jsonRequest = this.buildRequest(method, {params: args});
	var rid = uuid.v4();
	var data = {request: rid, json: jsonRequest}
	this.socket.on('response_'+rid, response.bind(this, rid, callback));
	this.socket.emit('api', data);
	if (__DEVELOPMENT__) {
		console.log('API Request', data);
	}
};

WebsocketsRpc.prototype.buildRequest = function(method, options) {
	if(options === undefined) {
		options = { id: 1 };
	}
	if (options.id === undefined) {
		options.id = 1;
	}
	var dataObj = {
		jsonrpc: '2.0',
		method: method,
		id: options.id
	};
	if(options.params !== undefined) {
		dataObj.params = options.params;
	}
	return dataObj;
};

export default WebsocketsRpc;


// WEBPACK FOOTER //
// ./src/utils/transport/websockets.js